export const stringFormatingToPascal = (value) => {
  if (!value) return value;
  let words = value.split(" ");
  if (!words) return "";
  return words
    .map(function (w) {
      return w.charAt(0).toUpperCase() + w.substr(1).toLowerCase();
    })
    .join(" ");
};
